import { j as i } from "../../../jsx-runtime-B6kdoens.js";
import { useEffect as C } from "react";
import { c as r } from "../../../index-CROKJrb5.js";
import { NavigationItemList as g } from "../NavigationItemList/index.js";
import { c as N, f as A } from "../../../create-component-CBAeEoQ6.js";
import { u as w } from "../../../use-dimensions-CSpaxs3M.js";
import { u as x } from "../../../NavigationState-EOPjgMu1.js";
import { u as a, a as b } from "../../../react-B_GApDuV.js";
const j = r({
  base: "cur-flex cur-relative cur-overflow-hidden cur-shrink",
  variants: {
    isCollapsed: {
      true: "cur-invisible"
    },
    hasComputed: {
      false: "cur-invisible"
    }
  }
}), D = r({
  base: "cur-overflow-hidden cur-pl-2",
  variants: {
    isCollapsed: {
      true: "cur-pointer-events-none -cur-z-10 cur-opacity-0 cur-invisible cur-h-1"
    }
  }
}), k = N(
  "NavigationFull",
  A(
    ({ children: l, className: n, ...m }, c) => {
      const { isCollapsedAtom: u, hasComputedAtom: p, isOverflowCollapsedAtom: f } = x(), s = a(u), d = a(p), o = b(f), [v, h] = w(), { width: e = 0, scrollWidth: t = 0 } = h || {};
      return C(() => {
        o(e, t);
      }, [o, e, t]), /* @__PURE__ */ i.jsx(
        "div",
        {
          className: j({
            className: n,
            hasComputed: d,
            isCollapsed: s
          }),
          ref: c,
          ...m,
          children: /* @__PURE__ */ i.jsx(
            g,
            {
              ref: v,
              className: D({ isCollapsed: s }),
              "aria-hidden": !!s,
              children: l
            }
          )
        }
      );
    }
  )
);
export {
  k as NavigationFull
};
//# sourceMappingURL=index.js.map
